import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/styles.css';
import './styles/bookModal.css'
import './styles/pageModal.css'
import './styles/jukebox.css'
import './styles/avatar.css'
import './styles/contact.css'
// import './styles/975.css'
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
